<template>
  <div id="admin-top-menu" class="topMenu">
    <div class="clear m1">
      <router-link
        to="/admin/admin_index"
        tag="div"
        class="clear-item item0"
        style="margin: 0 40px 0 30px;"
      >
        <img width="42px" src="../assets/images/indexlogo.png" alt />
      </router-link>
      <router-link
        to="/admin/admin_index"
        class="clear-item item1"
        :class="active==1?'active':''"
        @click="select(1)"
      >首页</router-link>
      <router-link
        to="/admin/list"
        class="clear-item item1"
        :class="active==2?'active':''"
        @click="select(2)"
      >商品</router-link>
      <router-link
        to="/admin/d_orderlist"
        class="clear-item item1"
        :class="active==3?'active':''"
        @click="select(3)"
      >订单</router-link>
      <router-link
        to="/admin/pur_wait"
        class="clear-item item1"
        :class="active==12?'active':''"
        @click="select(12)"
      >采购</router-link>
      <router-link
        to="/admin/y_userList"
        class="clear-item item1"
        :class="active==4?'active':''"
        @click="select(4)"
      >用户</router-link>
      <router-link
        to="/admin/c_integral"
        class="clear-item item1"
        :class="active==5?'active':''"
        @click="select(5)"
      >促销</router-link>
      <router-link
        to="/admin/groupList"
        class="clear-item item1"
        :class="active==6?'active':''"
        @click="select(6)"
      >权限</router-link>
      <router-link
        to="/admin/g_Setting"
        class="clear-item item1"
        :class="active==7?'active':''"
        @click="select(7)"
      >设置</router-link>
      <router-link
        to="/admin/inventoryList"
        class="clear-item item1"
        :class="active==8?'active':''"
        @click="select(8)"
      >库存</router-link>
      <router-link
        to="/admin/f_confirm"
        class="clear-item item1"
        :class="active==11?'active':''"
        @click="select(11)"
      >财务</router-link>
      <router-link
        to="/admin/clientList"
        class="clear-item item1"
        :class="active==9?'active':''"
        @click="select(9)"
      >销售</router-link>

      <router-link
        to="/admin/applylist"
        class="clear-item item1"
        :class="active==10?'active':''"
        @click="select(10)"
      >商户</router-link>
      <div class="left_position">{{this.$store.state.leftTitle}}</div>
    </div>
    <div class="right">
      <span class="item2">
        <i class="fas fa-user-circle fa-2x"></i>
        <span class="username">{{username}}</span>
      </span>

      <el-popover placement="top-start" width="424" trigger="hover">
        <span slot="reference" class="item2" @mouseenter="mag()">
          <i class="fas fa-home fa-2x"></i>
        </span>
        <div class="item2_hover2">
          <div class="hover2_div1">
            <div>账户信息</div>
            <div>账户设置</div>
          </div>
          <div class="hover2_div3">
            <div>
              <span>所在部门:</span>
              <span>{{group}}</span>
            </div>

            <div>
              <span>登陆地区:</span>
              <span>{{ip_address}}</span>
            </div>
            <div>
              <span>本次登陆:</span>
              <span>{{login_date}}</span>
            </div>
            <div>
              <span>Ip地址:</span>
              <span>{{ip}}</span>
            </div>
          </div>
        </div>
      </el-popover>

      <el-popover placement="top-start" width="424" trigger="hover">
        <span slot="reference" class="item2">
          <i class="fas fa-bars fa-2x"></i>
        </span>
        <div class="item2_hover2">
          <div class="hover2_div1">
            <div>常用菜单</div>
          </div>
          <div class="hover2_div2">
            <ul>
              <router-link to="/admin/list" tag="li">添加商品</router-link>
              <router-link to="/admin/d_orderlist" tag="li">订单列表</router-link>
              <router-link to="/admin/y_userList" tag="li">用户管理</router-link>
              <router-link to="/admin/c_integral" tag="li">秒杀管理</router-link>
              <router-link to="/admin/groupList" tag="li">权限管理</router-link>
              <router-link to="/admin/g_Setting" tag="li">设置信息</router-link>
            </ul>
          </div>
        </div>
      </el-popover>

      <el-popover placement="bottom" width="424" trigger="hover">
        <span slot="reference" class="item2 item_number">
          <i class="fas fa-bell fa-2x"></i>
          <div class="item_num">{{count0}}</div>
        </span>
        <div class="item2_hover">
          <ul>
            <li>
              <div>订单提示</div>
            </li>
            <li>
              <router-link to="/admin/d_orderlist?type=0" target="_blank">
                <div class="item2_hover_content">待付款订单</div>
              </router-link>

              <div>
                (
                <span>{{count1}}</span> )
              </div>
            </li>
            <li>
              <router-link to="/admin/d_orderlist?type=2" target="_blank">
                <div class="item2_hover_content">待发货订单</div>
              </router-link>

              <div>
                (
                <span>{{count3}}</span> )
              </div>
            </li>
            <li>
              <router-link to="/admin/d_orderlist?type=1" target="_blank">
                <div class="item2_hover_content">待采购订单</div>
              </router-link>

              <div>
                (
                <span>{{count2}}</span> )
              </div>
            </li>
            <li>
              <router-link to="/admin/d_orderlist?type=3" target="_blank">
                <div class="item2_hover_content">待收货订单</div>
              </router-link>

              <div>
                (
                <span>{{count4}}</span> )
              </div>
            </li>
          </ul>
        </div>
      </el-popover>
      <el-popover placement="top-start" width="50" trigger="hover">
        <span slot="reference" class="item2" style="cursor: pointer;" @click="return1()">
          <i class="fas fa-power-off fa-2x"></i>
        </span>
        <div @click="return1()" style="text-align:center;cursor:pointer">退出登录</div>
      </el-popover>
    </div>
    <el-dialog title="退出确定" :visible.sync="dialogVisible" width="25%">
      <span>确定要退出登录吗?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="return2()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      dialogVisible: false,
      //
      count0: 0,
      count1: 0,
      count2: 0,
      count3: 0,
      count4: 0,
      count5: 0,
      count6: 0,
      count7: 0,
      browser: "",
      group: "",
      ip: "",
      login_date: "",
      ip_address: "",
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      username: this.$cookies.get("username"),
      active: null,
      msg: "",
      router: "",
      menu: [
        [
          {
            title: "系统首页",
            path: "/admin/admin_index"
          },
          {
            title: "账户设置",
            path: "/admin/admin_account"
          },
          {
            title: "登录日志",
            path: "/admin/admin_journal"
          },

          {
            title: "服务消息",
            path: "/admin/admin_serve"
          },
          {
            title: "活动消息",
            path: "/admin/admin_activity"
          }
        ],
        [
          {
            title: "商品列表",
            path: "/admin/list"
          },
          {
            title: "添加商品",
            path: "/admin/add1"
          },

          {
            title: "商品评价",
            path: "/admin/OrderRate"
          },
          {
            title: "商品分类",
            path: "/admin/edit_category"
          },
          {
            title: "品牌管理",
            path: "/admin/brand"
          },

          {
            title: "图片管理",
            path: "/admin/gallery"
          },
          {
             title: "库存修改",
             path: "/admin/d_inventory"
           }/*,
          {
            title: "供应商表",
            path: "/admin/supplierList"
          },
          {
            title: "寻源列表",
            path: "/admin/bioLookList"
          },
          {
            title: "货源供应",
            path: "/admin/looksupplierList"
          }*/
        ],
        [
          {
            title: "订单列表",
            path: "/admin/d_orderlist"
          },
          {
            title: "订单确认",
            path: "/admin/d_finance"
          },
          /*{
            title: "等待采购",
            path: "/admin/wait_buy_order"
          },*/
          {
            title: "采购记录",
            path: "/admin/d_advice"
          },
          {
            title: "发货提醒",
            path: "/admin/d_Shipment"
          },
           {
             title: "订单完成",
             path: "/admin/d_orderDone"
           },
           {
             title: "取消订单",
             path: "/admin/d_orderCall"
           },
          {
            title: "账期提醒",
            path: "/admin/d_orderPayment"
          },

          {
            title: "退货申请",
            path: "/admin/d_returns"
          },
          {
            title: "退款申请",
            path: "/admin/d_refund"
          }
        ],
        [
          {
            title: "用户列表",
            path: "/admin/y_userList"
          },
          {
            title: "积分查询",
            path: "/admin/y_integral"
          },
          {
            title: "积分规则",
            path: "/admin/y_itgRule"
          },
          {
            title: "主账户功能",
            path: "/admin/y_main"
          },
          {
            title: "账期列表",
            path: "/admin/y_payments_user"
          },
          {
            title: "用户反馈",
            path: "/admin/y_feedback"
          },
          {
            title: "店铺投诉",
            path: "/admin/y_shopfeedback"
          },
          {
            title: "编辑税号",
            path: "/admin/y_duty"
          },
           {
             title: "闲置交换审核",
             path: "/admin/y_exchange"
           },
           {
             title: "bioflinnews审核",
             path: "/admin/y_audit"
           },
          {
            title: "佣金列表",
            path: "/admin/y_brokerage"
          }
          // ,
          // {
          //   title: "客服信息",
          //   path: "/admin/y_service"
          // }
        ],
        [
          {
            title: "积分商城",
            path: "/admin/c_integral"
          },

          {
            title: "折扣商品",
            path: "/admin/c_preference"
          },
          {
            title: "商品排行",
            path: "/admin/c_popularity"
          },
          {
            title: "发现好货",
            path: "/admin/lookGood"
          },

          {
            title: "必抢清单",
            path: "/admin/c_items"
          },
          {
            title: "优惠券表",
            path: "/admin/c_special"
          },
          // {
          //   title: "秒杀活动列表",
          //   path: "/admin/c_seckill"
          // },

          {
            title: "团购商品",
            path: "/admin/c_groupList"
          },
          {
            title: "秒杀时间",
            path: "/admin/c_seckillTime"
          },
          {
            title: "分类广告",
            path: "/admin/c_classified"
          },
          {
            title: "分享推荐",
            path: "/admin/c_share_product"
          }
        ],
        [
          {
            title: "部门管理",
            path: "/admin/groupList"
          },
          {
            title: "操作日志",
            path: "/admin/adminLog"
          },
          {
            title: "管理员列表",
            path: "/admin/permission"
          }
        ],
        [
          {
            title: "平台信息",
            path: "/admin/g_Setting"
          },
          {
            title: "物流公司",
            path: "/admin/g_logistics"
          },
          {
             title: "支付设置",
             path: "/admin/g_setPay"
           },

          {
            title: "楼层广告",
            path: "/admin/g_advertising"
          },
          {
            title: "横幅广告",
            path: "/admin/g_advertising1"
          },
          // {
          //   title: "常见问题",
          //   path: "/admin/g_issue"
          // },
          {
            title: "文章编写",
            path: "/admin/g_adminProtocol"
          },
          // {
          //   title: "短信设置",
          //   path: "/admin/g_note"
          // },
          {
            title: "搜索热词",
            path: "/admin/g_reci"
          },
          {
            title: "热点新闻",
            path: "/admin/admin_system"
          },
          {
            title: "首页公告",
            path: "/admin/g_notice"
          },
          {
            title: "首页通知",
            path: "/admin/g_notices"
          },
          {
            title: "搜索广告",
            path: "/admin/g_adCommodity"
          }
        ],
        [
          {
            title: "库存管理",
            path: "/admin/inventoryList"
          },
          {
            title: "出库记录",
            path: "/admin/inventoryLog2"
          },
          {
            title: "入库记录",
            path: "/admin/inventoryLog3"
          }
          // {
          //   title: '退换清单',
          //   path: '/admin/list'
          // },
        ],
        [
          {
            title: "我的客户",
            path: "/admin/clientList"
          },
          {
            title: "应收账款",
            path: "/admin/callIn"
          },
          {
            title: "客户订单",
            path: "/admin/sell_orderList"
          }
          // {
          //   title: '申请退货',
          //   path: '/admin/list'
          // },
        ],
        [
          // {
          //   title: "商户列表",
          //   path: "/admin/shoplist"
          // },
          {
            title: "入驻商申请",
            path: "/admin/applylist"
          },
          {
            title: "入驻商列表",
            path: "/admin/shopLists"
          },
           {
            title: "待审核商品",
            path: "/admin/applyProduct"
          },
          {
            title: "商品列表",
            path: "/admin/shopproduct"
          },
          {
            title: "订单列表",
            path: "/admin/shopOrderList"
          },
          {
            title: '佣金结算',
            path: '/admin/shopOrderAccount'
          },
          {
            title: '操作日志',
            path: '/admin/applyLog'
          }
        ],
        [
          {
            title: "订单确认",
            path: "/admin/f_confirm"
          },
          /*{
            title: "支付确认",
            path: "/admin/f_confirm_pay"
          },*/
          {
            title: "账期列表",
            path: "/admin/f_payment"
          },
          {
            title: "退款订单",
            path: "/admin/f_return_money"
          },
          {
            title: "退货订单",
            path: "/admin/f_return_product"
          },
          {
            title: "白条申请",
            path: "/admin/f_apply_card"
          },
          {
            title: "白条列表",
            path: "/admin/f_card_pay"
          }
        ],
        [
          {
            title: "待采购订单",
            path: "/admin/pur_wait"
          },
          {
            title: "已采购订单",
            path: "/admin/pur_advice"
          },
          {
            title: "供应商表",
            path: "/admin/supplierList"
          },
          {
            title: "寻源列表",
            path: "/admin/bioLookList"
          },
          {
            title: "货源供应",
            path: "/admin/looksupplierList"
          }
        ]
      ]
    };
  },
  props: {
    //
  },

  // this.router = this.$route.name.split(".")[1];

  methods: {
    logout() {
      this.$cookies.remove("token");
      this.$cookies.remove("user");
      this.$router.push("/");
    }
  },
  watch: {
    "$store.state.topActiveId": {
      handler: function(newer, older) {
        this.active = newer;
        this.select(newer);
      },
      deep: true
    },
    "$store.state.order": {
      handler: function(n, o) {
        this.order_name = n;
      }
    },
    $route(v) {}
  },
  created() {
    this.axios(this.serve + "/admin/order_header", {
      params: {
        username: this.username,
        token: this.token
      }
    }).then(res => {
      if (res.data.status == "success") {
        var count = res.data.data;
        this.count0 = count.num_0 + count.num_1 + count.num_2 + count.num_3;
        this.count1 = count.num_0;
        this.count2 = count.num_1;
        this.count3 = count.num_2;
        this.count4 = count.num_3;
        this.count5 = count.num_4;
        this.count6 = count.num_5;
        this.count7 = count.num_6;
      }
    });
  },
  methods: {
    mag() {
      this.axios
        .get(this.serve + "/admin/admin_user_detail", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          var json = res.data.data;
          this.browser = json.browser;
          this.group = json.group;
          this.ip = json.ip;
          this.login_date = json.login_date;
          this.ip_address = json.ip_address;
        });
    },
    return2() {
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/exit_login", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          this.msg = res.data.msg;
          if (res.data.status == "success") {
            this.dialogVisible = false;
            this.username = "";
            this.$message({
              type: "success",
              message: this.msg
            });
            this.$router.push({
              path: "/"
            });
            window.location.reload();
          } else if (res.data.status == "error") {
            this.$message({
              type: "error",
              message: this.msg
            });
          }
        });
    },
    return1() {
      this.dialogVisible = true;
    },
    select(i) {
      this.$router.push({
        path: this.menu[i - 1].path
      });
      this.active = i;
      this.$store.commit("changeMenu", this.menu[i - 1]);
    }
  }
};
</script>

<style lang="scss">
.el-dialog__header {
  background: #f5f5f5;
}
.el-dialog__body {
  border-bottom: 1px solid #ddd;
}
.item0 {
  cursor: pointer;
}
.item2_hover2 {
  // background: orange;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  .hover2_div1 {
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    list-style: none;
    padding-left: 10px;
    padding-right: 10px;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
    div:hover {
      color: #0099ff;
    }
  }
  .hover2_div3 {
    margin-top: 30px;
    div {
      width: 300px;
      height: 50px;
      line-height: 50px;
      padding-left: 10px;
      padding-right: 10px;
      > :nth-child(1) {
        margin-right: 20px;
        font-size: 14px;
        font-family: MicrosoftYaHeiLight;
        font-weight: 300;
        color: rgba(153, 153, 153, 1);
      }
    }
  }
  .hover2_div2 {
    width: 400px;
    margin-top: 30px;

    > ul {
      li {
        margin-right: 1px;
        margin-bottom: 1px;
        height: 50px;
        line-height: 50px;
        float: left;
        width: 100px;
        list-style: none;
        cursor: pointer;
      }
      li:hover {
        color: #0099ff;
      }
    }
  }
}
.item2_hover {
  //  background: orange;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  padding-bottom: 30px;
  > ul {
    padding: 0;
    margin: 0;
    width: 90%;
    margin: 0 auto;
  }
  li {
    display: flex;
    height: 40px;
    line-height: 40px;
    justify-content: space-between;
    list-style: none;
    padding-left: 10px;
    padding-right: 10px;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
  }
  .item2_hover_content {
    color: #333;
  }
  li:hover .item2_hover_content {
    color: #0099ff;
  }
}

#admin-top-menu {
  .m1 a {
    color: #fff;
  }
  min-width: 1480px;
  display: flex;
  background-color: #3498db;
  color: #fff;
  justify-content: space-between;
  .m1 {
    position: relative;
    .left_position {
      width: 180px;
      height: 49px;
      background: rgba(238, 238, 238, 1);
      line-height: 50px;
      text-align: center;
      border: 1px solid rgba(221, 221, 221, 1);

      position: absolute;
      left: 0;
      top: 48px;
      font-size: 16px;
      font-family: MicrosoftYaHeiLight;
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
    }
    .item1 {
      line-height: 48px;
      width: 80px;
      text-align: center;
      cursor: pointer;
    }
    .item1:hover,
    .active.item1 {
      background-color: #5fbfff;
    }
  }
  .right {
    position: relative;
    // .news.item2:hover .item2_hover{
    //   display: block;
    // }

    .item2 {
      // padding: 0 30px;
      color: #fff;
      line-height: 48px;
      margin-right: 40px;
      cursor: pointer;
      svg {
        color: #fff;
        line-height: 48px;
        position: relative;
        top: 5px;
      }
      .username {
        color: #fff;
        margin-left: 5px;
      }
    }
    .item_number {
      position: relative;
      .item_num {
        position: absolute;
        top: -3px;
        right: -6px;
        /* width: 18px; */
        height: 18px;
        line-height: 18px;
        padding-left: 1px;
        padding-right: 1px;
        text-align: center;
        background: rgba(227, 104, 68, 1);
        border-radius: 50%;
        font-size: 8px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}
</style>
